export default __webpack_public_path__ + "static/media/Tsurugi_Swimsuit.e252d94f.png";